import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { ADG4CtaWithPolygonBackground } from "@/patterns/adg4/cta-with-polygon-background/cta-with-polygon-background";

export const CtaSection = () => {
    const intl = useIntl();
    return (
        <UFOSegment name="enterprise-page-cta">
            <section css={ctaSectionContainerStyle}>
                <ADG4CtaWithPolygonBackground
                    header={intl.formatMessage({
                        id: "EnterpriseLandingPage.CallToActionSection.header",
                        defaultMessage:
                            "Build your system of work with Atlassian"
                    })}
                    ctaText={intl.formatMessage({
                        id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                        defaultMessage: "Contact sales"
                    })}
                    ctaUrl={useLocalizedHref(
                        "/enterprise/contact?formType=product-features"
                    )}
                    ctaLabel="Contact sales"
                    productKey="enterprise"
                />
            </section>
        </UFOSegment>
    );
};

const ctaSectionContainerStyle = css({
    backgroundImage: "linear-gradient(to bottom, #f0f2f4 50%, transparent 50%)",
    padding: "40px 0",
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    section: {
        margin: "0 auto"
    }
});
